

















































































































import Vue from 'vue';
import Component from 'vue-class-component';
import {i18nModule, userModule, userState, userTeamInvitesModule, userTeamInvitesState} from '@/utils/store-acessor';
import {InvitationMode, InvitationsModel, InvitationStatus} from '@/models/team.model';
import {UserModel} from '@/models/user.model';
import ListScaffold from '@/components/Shared/ListScaffold.vue';
import {bottomVisible} from '@/utils/utils';
import {Watch} from 'vue-property-decorator';
import {LocaleSelectorType} from '@/store/i18n.store.module';
import {ChallengeModel, Translated} from '@/models/challenge.model';

export interface InviteFilter {
  label: string;
  value: InvitationStatus | InvitationMode;
}

@Component({
  components: {ListScaffold}
})
export default class ProfileInvitations extends Vue {
  @userTeamInvitesModule.Getter('loading') loading!: boolean;
  @userTeamInvitesModule.Getter('lastPage') lastPage!: number;
  @userTeamInvitesModule.Getter('currentPage') currentPage!: number;
  @userTeamInvitesModule.Getter('entities') invites!: InvitationsModel[];
  loadingTeam: boolean = false;
  @i18nModule.Getter('locale') locale!: LocaleSelectorType;

  @userTeamInvitesModule.Getter('invitesByStatus')
  invitesByStatus!: (status: InvitationStatus) => InvitationsModel[];

  @userTeamInvitesModule.Getter('invitesByMode')
  invitesByMode!: (mode: InvitationMode) => InvitationsModel[];

  @userTeamInvitesModule.Getter('invitesByModeAndStatus')
  invitesByModeAndStatus!: (
          mode: InvitationMode,
          status: InvitationStatus
  ) => InvitationsModel[];

  @userModule.Getter('user') user!: UserModel;

  statusSelected: InviteFilter | null = null;
  modeSelected: InviteFilter | null = null;
  filterByStatus: InviteFilter[] = [
    {label: 'team.invites.status.accepted', value: 'accepted'},
    {label: 'team.invites.status.canceled', value: 'canceled'},
    {label: 'team.invites.status.pending', value: 'pending'},
    {label: 'team.invites.status.rejected', value: 'rejected'},
    {label: 'team.invites.status.removed', value: 'removed'},
  ];

  filterByMode: InviteFilter[] = [
    {label: 'team.invites.mode.invited', value: 'invited'},
    {label: 'team.invites.mode.requested', value: 'requested'},
  ];

  async mounted() {
    await userState.fetchUser();
    if (this.user?.id) {
      this.requestWithFilters();
    }
    window.addEventListener('scroll', () => {
      if (bottomVisible()) {
        this.loadMore();
      }
    });
  }

  inviteStatusI18n(invite: InvitationsModel): string {
    return this.$t(
            `team.invites.messages.${invite.invitation_mode}.${invite.status}`
    ).toString();
  }

  get getInvitesByFilter(): InvitationsModel[] {
    const status = this.statusSelected?.value as InvitationStatus;
    const mode = this.modeSelected?.value as InvitationMode;
    if (!mode && !status) {
      return this.invites;
    }
    if (mode) {
      if (!status) {
        return this.invitesByMode(mode);
      }
      return this.invitesByModeAndStatus(mode, status);
    } else {
      return this.invitesByStatus(status);
    }
  }

  openTeamPage(invitation: InvitationsModel): void {
    this.loadingTeam = true;
    if (invitation?.team?.id && invitation?.team?.challenge?.slug) {
      this.$router.push({
        name: 'show-team-members',
        params: {
          slug: invitation.team.challenge.slug,
          teamSlug: `${invitation.team.slug}`
        }
      });
    }
  }

  acceptInvitation(invitation: InvitationsModel): void {
    if (
            invitation?.id &&
            invitation?.team?.id &&
            invitation?.team?.challenge_id
    ) {
      userTeamInvitesState.acceptInvite({
        inviteId: invitation.id,
        teamId: invitation.team.id,
        challengeId: invitation.team.challenge_id
      });
    }
  }

  refuseInvitation(invitation: InvitationsModel): void {
    if (
            invitation?.id &&
            invitation?.team?.id &&
            invitation?.team?.challenge_id
    ) {
      userTeamInvitesState.rejectInvite({
        inviteId: invitation.id,
        teamId: invitation.team.id,
        challengeId: invitation.team.challenge_id
      });
    }
  }

  challengeTitle(challenge: ChallengeModel): string {
    console.log(challenge);
    const locale = this.locale.value;
    const title = challenge?.title as Translated;
    if (!!title) {
      switch (locale) {
        case 'en':
          // @ts-ignore
          return title.en || title;
        case 'ptBr':
          // @ts-ignore
          return title.pt || title
      }
    }
    return '';
  }

  @Watch('statusSelected')
  async onStatusChange(value: InviteFilter): Promise<void> {
    const mode = this.modeSelected?.value as InvitationMode;
    const status = value?.value as InvitationStatus;
    await this.requestWithFilters(this.currentPage + 1, status, mode);
  }

  @Watch('modeSelected')
  async onModeChange(value: InviteFilter): Promise<void> {
    const mode = value?.value as InvitationMode;
    const status = this.statusSelected?.value as InvitationStatus;
    await this.requestWithFilters(this.currentPage + 1, status, mode);
  }

  private async requestWithFilters(
          page: number = 1,
          status?: InvitationStatus,
          mode?: InvitationMode
  ): Promise<void> {
    await userTeamInvitesState.fetchAllInvitations({
      params: {page},
      status,
      mode
    });
  }

  private async loadMore() {
    if (this.currentPage < this.lastPage && !this.loading) {
      const mode = this.modeSelected?.value as InvitationMode;
      const status = this.statusSelected?.value as InvitationStatus;
      await this.requestWithFilters(this.currentPage + 1, status, mode);
    }
  }
}
